// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__NGeeE","actionsCol":"EnrolledClinics_actionsCol__RVooU"};